import React, { useState } from "react";
import { Required } from "../../components/RegEx/ValidationMessage";
import { useHistory } from "react-router-dom";
import http from "../../config/BaseUrl";
import LocalStorage from "../../hook/LocalStorage";

function Form(props) {

  const { user } = LocalStorage();
  
  // const { submittedData } = props
  const { register, errors, watch, setValue} = props
  const history = useHistory()

  const cardNumberSpacing = (e) => {
    let valued = e.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    
    setCardNumber(valued)
  }

  const cardValidation = (e) => {
    let flag;
    if (
      e.keyCode === 8 ||
      e.keyCode === 9 ||
      (e.keyCode === 16 && e.keyCode >= 9) ||
      e.keyCode === 37 ||
      e.keyCode === 39 ||
      e.keyCode === 46 ||
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105)
    ) {
      flag = false;
    } else {
      flag = true;
    }

    if (flag) {
      e.preventDefault();
    }
  };

  const [cardNumber, setCardNumber] = useState("");
  const [cardName, setCardName] = useState("");
  const [expMonth, setExpMonth] = useState("");
  const [expYear, setExpYear] = useState("");
  const [cvv, setCvv] = useState("");

  const handleSubmitForm = (data) => {
    // const formData = {
    //   cardNumber:data.cardNumber,
    //   cardholderName:data.cardholderName,
    //   cvvNumber:data.cvvNumber,
    //   expiryMonth:data.expiryMonth,
    //   expiryYear:data.expiryYear,
    //   user_id:user.id,
    //   user_email:user.email,
    //   submittedData:submittedData
    // }
    // http.post("member-ship", formData).then((res) =>{
    //  if(res.data.card_info){
    //   history.push('/dashboard')
    //  }
    // })

  }

  const handleField = (e) => {
    const { maxLength, value, id } = e.target;
    const [fieldId, fieldIndex] = id.split("-");

    // Check if they hit the max character length
    if (value.length >= maxLength) {
      // Check if it's not the last input field
      if (parseInt(fieldIndex, 10) < 3) {
        // Get the next input field
        const nextSibling = document.querySelector(
          `#field-${parseInt(fieldIndex, 10) + 1}`
        );

        // If found, focus the next field
        if (nextSibling !== null) {
          nextSibling.focus();
        }
      }
    }
  };
  return (
    <>

      

      <div className="form-group">
        <label htmlFor="CardNumber">Card Number</label>
        <input
          id="CardNumber"
          type="text"
          name="cardNumber"
          className={`form-control ${errors.cardNumber ? "is-invalid":""}`}
          maxLength="19"
          placeholder="Card number"
          {...register("cardNumber", { required: Required })}
          onChange={(e) => {
            cardNumberSpacing(e.target.value)
            
          }}
          value={cardNumber}
          onKeyDown={cardValidation.bind(this)}
        />
        <small className="text-danger">{errors.cardNumber && errors.cardNumber.message}</small>
      </div>

      <div className="form-group">
      <label htmlFor="CardHolderName">Card Holder Name</label>
        <input
          id="CardHolderName"
          type="text"
          name="cardholderName"
          className={`form-control ${errors.cardholderName ? "is-invalid":""}`}
          placeholder="Card holder name"
          isError={errors.cardholderName}
          {...register("cardholderName", { required: Required })}
          onChange={(e) => {
            setCardName(e.target.value);
          }}
          value={cardName} 
        />
        <div>
          <small className="text-muted">Full name as displayed on card</small>
        </div>
      </div>

      <div className="form-row">
        <div className="mb-0 form-group col-12">
          <label>Expiry date</label>
        </div>
        <div className="form-group col-md-3 col-6">
          <input
            label=""
            type="text"
            maxLength="2"
            placeholder="MM"
            name="expiryMonth"
            id="field-1"
            className={`form-control ${errors.expiryMonth ? "is-invalid":""}`}
           
            {...register("expiryMonth", { required: Required })}
            onChange={(e) => {
              setExpMonth(e.target.value);
              handleField(e);
            }}
            value={expMonth}
            onKeyDown={cardValidation.bind(this)}
          />
        </div>

        <div className="form-group col-md-3 col-6">
          <input
            label=""
            type="text"
            maxLength="2"
            placeholder="YY"
            name="expiryYear"
            id="field-2"
            className={`form-control ${errors.expiryMonth ? "is-invalid":""}`}
            {...register("expiryYear", { required: Required })}
            onChange={(e) => {
              setExpYear(e.target.value);
              handleField(e);
            }}
            value={expYear}
            onKeyDown={cardValidation.bind(this)}
          />
        </div>

        <div className="form-group col-md-6 col-12">
          <input
            label=""
            type="text"
            maxLength="6"
            placeholder="CVV Number"
            name="cvvNumber"
            className={`form-control ${errors.cvvNumber ? "is-invalid":""}`}
            {...register("cvvNumber", { required: Required })}
            onChange={(e) => {
              setCvv(e.target.value);
            }}
            value={cvv}
            onKeyDown={cardValidation.bind(this)}
          />
        </div>
      </div>

    </>
  );
}

export default Form;
